// ensure the main object is defined
if (typeof(so) === 'undefined') {
    var so = {};
}

// main code
so.app = {
    init: function () {
        this.swipeboxInit();
    },
    swipeboxInit: function(){
        $('.swipebox').swipebox({
            useSVG: false,
            loopAtEnd: true,
            hideBarsDelay : 0,
            afterOpen: function() {
                var $selectorClose = $("#swipebox-close");
                var clickAction = "touchend click";
    
                $selectorClose.unbind(clickAction);
    
                $selectorClose.bind(clickAction, function(event) {
                    event.preventDefault();
                    event.stopPropagation();
    
                    $.swipebox.close();
                });
            }
        });
    },
};

$(document).ready(function () {
    so.app.init();
});


// WEBPACK FOOTER //
// ./client/src/javascript/swipe-init.js